import React from 'react';
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router';

const Header = () => {
  const { pathname } = useLocation();
  return (
    <div className={`header ${pathname === '/' ? 'index-header' : ''}`}>
      <div className="logo">
        {pathname === '/' ?
          <img src={process.env.PUBLIC_URL + '/images/logo-index.png'} alt="logo" />
          : <img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="logo" />}
      </div>
      <div className="navigator">
        <Link className={`link ${pathname === '/' ? 'active' : ''}`} to="/">首页</Link>
        <Link className={`link ${pathname === '/information' ? 'active' : ''}`} to="/information">公司概况</Link>
        <Link className={`link ${pathname.startsWith('/projects') ? 'active' : ''}`} to="/projects/1">项目情况</Link>
      </div>
    </div>
  );
};

export default Header;
